import axios from "axios";
import qs from "qs";
import { wrapper } from "@/stores";
import { renewAccessToken } from "@/stores/apis/apiAuth";
import { getCookie } from "cookies-next";

const API_URL = process.env.NEXT_PUBLIC_API_URL;

var client = axios.create({
	baseURL: API_URL,
	responseEncoding: "utf8",
	paramsSerializer: function (query) {
		return qs.stringify(query, { arrayFormat: "repeat" });
	},
});

client.interceptors.response.use(undefined, async (err) => {
	const error = err.response;

	if (error.status === 401 && error.config && !error.config.__isRetryRequest) {
		const token = await wrapper?.dispatch(renewAccessToken());
		if (token) {
			error.config.__isRetryRequest = true;
			error.config.headers.authorization = "Bearer " + token;
			return client(error.config);
		} else {
			// force sign out and navigate homepage
			throw error.data;
		}
	} else if (error.status !== 200 && error.status !== 201 && error.status !== 401) {
		throw error.data;
	}
});

async function buildRequest(method, headerProps, anonymous = false) {
	let request = {
		headers: {
			Accept: "application/json",
			// 'Access-Control-Allow-Origin': '*',
			"Content-Type":
				headerProps && headerProps["Content-Type"] ? headerProps["Content-Type"] : "application/json",
			...headerProps,
		},
	};

	if (!anonymous) {
		const access_token = getCookie("ACCESS_TOKEN");
		if (access_token) {
			// const access_token = values && values.access_token;
			request.headers["authorization"] = "Bearer " + access_token;
		}
	}
	return request;
}

const API = {
	get: async function (resource, query, headers) {
		try {
			let params = "";
			if (query) {
				params = Object.keys(query).reduce((q, key) => {
					return q + `&${key}=${query[key]}`;
				}, "?");
			}

			let options = await buildRequest("GET", headers);
			return await client.get(`${API_URL}/p${resource}`, {
				...options,
				params: query,
			});
		} catch (err) {
			if (err && err.response && err.response.status === 401) {
				throw {
					error: "SESSION_NOT_FOUND",
				};
			} else {
				throw err;
			}
		}
	},
	get_origin: async function (resource, query, headers) {
		try {
			let params = "";
			if (query) {
				params = Object.keys(query).reduce((q, key) => {
					return q + `&${key}=${query[key]}`;
				}, "?");
			}

			let options = await buildRequest("GET", headers);
			const response = await client.get(`${API_URL}${resource}${params}`, options);

			return response;
		} catch (err) {
			throw err;
		}
	},
	post: async function (resource, data, headers, anonymous) {
		try {
			let options = await buildRequest("POST", headers, anonymous);
			return await client.post(`${API_URL}/p${resource}`, data, options);
		} catch (err) {
			throw err;
		}
	},
	post_origin: async function (resource, data, headers, anonymous) {
		try {
			let options = await buildRequest("POST", headers, anonymous);
			return await client.post(`${API_URL}${resource}`, data, options);
		} catch (err) {
			throw err;
		}
	},
	put: async function (resource, data, headers) {
		try {
			return await client.put(`${API_URL}/p${resource}`, data, await buildRequest("PUT", headers));
		} catch (err) {
			throw err;
		}
	},
	put_origin: async function (resource, data, headers) {
		try {
			return await client.put(`${API_URL}${resource}`, data, await buildRequest("PUT", headers));
		} catch (err) {
			throw err;
		}
	},
	delete: async function (resource, data, headers) {
		try {
			let options = await buildRequest("DELETE", headers);
			if (data) {
				options.params = data;
				options.data = data;
			}

			return await client.delete(API_URL + "/p" + resource, options);
		} catch (err) {
			throw err;
		}
	},
};

export default API;
